
 var store  = require('amplify-store');

var LocalStorageService = {

       Persist: function (persistenceKey, data) { 
                try { store(persistenceKey, data) 
                } 
                catch (e) { 
                    events.emitter.emit(events.error, 'storage quota reached') 
                }
            },

        Retrieve: function (persistenceKey) {
                            var item = store(persistenceKey);
                            item || console.error('unable to locate stored file with key', persistenceKey);
                            return item
                        },
        Remove: function (persistenceKey) { 
                try { store(persistenceKey, null) 
                } 
                catch (e) { 
                    events.emitter.emit(events.error, 'unable to clear key: ' + persistenceKey) ;
                }
            },

        AllKeys: function(){
                    return _.keys(store());
                 }




}

module.exports = LocalStorageService;

